import { CheckCircle2 } from "lucide-react"
import { Button } from "@/components/ui/button"
import { SocialConnection } from "@/components/Login/SocialConnection"
import { useTranslation } from 'react-i18next'

// Account Step
export function AccountStep({
    value,
    onChange,
    onNext,
}: {
    value: string
    onChange: (value: string) => void
    onNext: () => void
}) {
    const { t } = useTranslation()

    const advantages = [
        t('onboarding.account.advantages.saveReadings'),
        t('onboarding.account.advantages.personalNotes'),
        t('onboarding.account.advantages.syncedDevices'),
        t('onboarding.account.advantages.aiInsights'),
        t('onboarding.account.advantages.dailyCompanion'),
    ]

    return (
        <div className="flex flex-col h-full">
            <div className="flex-1 space-y-4 sm:space-y-6 overflow-y-auto">
                <h2 className="text-xl sm:text-2xl font-serif text-center text-[#3d405b] px-2">{t('onboarding.account.title')}</h2>

                <ul className="space-y-2 sm:space-y-3">
                    {advantages.map((advantage, index) => (
                        <li key={index} className="flex items-center">
                            <CheckCircle2 className="h-6 w-6 sm:h-8 sm:w-8 text-[#7b63ab] mr-2 flex-shrink-0" />
                            <span className="text-sm sm:text-base text-gray-700">{advantage}</span>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="mt-auto pt-4">
                <SocialConnection
                    value={value}
                    onChange={onChange}
                    onNext={onNext}
                />
            </div>
        </div>
    )
}
